export default "__VITE_ASSET__fgpI32SH__"